import 'pages/images/image-gallery.tag'
riot.tag2('images', '  <div class="row" if="{!notFound}">\n    <div class="col-sm-2 hidden-xs">\n      <ul class="nav nav-pills nav-stacked">\n        <li class="{active: name == tab}" each="{tabs}"><a href="#images/{link}">{title}</a></li>\n      </ul>\n    </div>\n    <div class="col-xs-12 hidden-sm hidden-lg hidden-md form-group">\n      <select class="form-control" onchange="{menuSelect}">\n        <option each="{tabs}" value="{name}" __selected="{name == tab}" no-reorder>{title}</option>\n      </select>\n    </div>\n    <div class="col-sm-10 col-xs-12">\n      <image-gallery name="gallery"></image-gallery>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this,
    route = riot.route.create(),
    path;

self.state = {};

route('/images/*', function (tab) {
    if (self.tabs.map(function (i) {
        return i.name;
    }).indexOf(tab) !== -1) {
        self.notFound = false;
        self.tab = tab;

        self.tabs.forEach(function (item) {
            if (item.name == tab) path = item.path;
        });

        if (!self.state[self.tab]) {
            self.state[self.tab] = {};
            self.state[self.tab].section = path;
            self.state[self.tab].limit = self.tags.gallery.pages.limit;
            self.state[self.tab].offset = 0;
        }

        self.tags.gallery.update({ params: self.state[self.tab] });
        self.tags.gallery.reload();

        self.update();
    } else {
        self.notFound = true;
        self.update();
        observable.trigger('not-found');
    }
});

observable.on('images-page-change', function (params) {
    self.state[self.tab] = params;
});

self.tab = '';
self.tabs = [{ title: 'Товары', name: 'products', link: 'products', path: 'shopprice' }, { title: 'Категории товаров', name: 'categories', link: 'categories', path: 'shopgroup' }, { title: 'Новости', name: 'news', link: 'news', path: 'newsimg' }, { title: 'Бренды', name: 'brands', link: 'brands', path: 'shopbrand' }, { title: 'Параметры товаров', name: 'products-options', link: 'products-options', path: 'shopfeature' }, { title: 'Платежные системы', name: 'pay-systems', link: 'pay-systems', path: 'shoppayment' }, { title: 'Контакты', name: 'persons', link: 'persons', path: 'contacts' }, { title: 'Разделы', name: 'sections', link: 'sections', path: 'sections' }, { title: 'Заказы', name: 'orders', link: 'orders', path: 'orders' }];

self.menuSelect = function (e) {
    riot.route('/images/' + e.target.value);
};

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/images/images.tag